export default class Model {
	constructor(imageMap) {
		this._imageMap = imageMap;
	}

	get imageMap() {
		return this._imageMap;
	}
}
